/* eslint-disable import/prefer-default-export */

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useObiIdAndPortNumber = () => {
  const box = useSelector(state => state.AppState.boxDetails.box);
  const selectedPort = useSelector(state => state.UIState.epikBoxDetails.selectedPort);
  const selectedObi = useSelector(state => state.UIState.epikBoxDetails.selectedObi);

  // eslint-disable-next-line no-console
  console.info({ selectedPort, selectedObi });

  const requiredData = useMemo(() => {
    const portNumber = +selectedPort?.boxPortNumber.replace(/[A-Za-z]/g, '');
    const checkObi = Math.ceil(portNumber / 2) - 1;
    const obiId = box?.Obis[checkObi]?._id || '';
    return {
      portNumber,
      checkObi,
      obiId,
    };
  }, [box, selectedPort, selectedObi]);

  const { portNumber, checkObi, obiId } = requiredData;

  return {
    obiId,
    portNumber,
    obiIndexInBox: checkObi,
  };
};
